<template>
  <vs-card>
    <vs-row class="head">
      <vs-col vs-w="8">
        <h4>Információs szöveg szerkesztése</h4>
      </vs-col>
      <vs-col vs-w="4" vs-type="flex" vs-align="center" vs-justify="flex-end">
        <vs-button v-if="!editMode" radius color="warning" size="small" type="gradient" icon="build"
                   @click="editInfo()"></vs-button>
        <vs-button v-if="editMode" radius color="success" size="small" type="gradient" icon="check"
                   @click="save()"></vs-button>
        <vs-button v-if="editMode" radius color="danger" size="small" type="gradient" icon="clear"
                   @click="cancel()"></vs-button>
      </vs-col>
    </vs-row>
    <vs-row>
      <editor id="tiny" v-model="info.OptionValue" api-key="kvck7qgyyxamqkjb6h7pe13ope4pdifo5aekmumqyqhm8oh8" :disabled="!editMode"
              :init="{
                  menubar: true,
                  statusbar: false,
                  width: '100%',
                  toolbar: 'undo redo | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link',
                  language: 'hu_HU',
                  entity_encoding : 'raw',
                  plugins: [
                      'advlist autolink lists link charmap print preview anchor', 'searchreplace visualblocks code fullscreen', 'insertdatetime table paste imagetools wordcount'
                  ]
      }"
      />
    </vs-row>
  </vs-card>
</template>

<script>

import {axiosInstance} from '@/main';
import editor from "@tinymce/tinymce-vue";

export default {
  name: 'information',
  components: {
    editor
  },
  data() {
    return {
      editMode: false,
      info: {}
    }
  },
  methods: {
    getInformation() {
      let self = this;
      axiosInstance
          .get("admin/optionsController.php?name=informationText", {
            withCredentials: true,
          })
          .then((resp) => {
            self.info = resp.data.responseData[0];
          })
          .catch((err) => {
            if (err.response.status === 401)
              self.$root.exterminatus();
            else {
              self.$vs.notify({
                title: 'Rendszerüzenet',
                position: 'top-right',
                text: err.response.data.message,
                color: 'danger',
                icon: 'error'
              });
            }
          });
    },
    save() {
      let self = this;
      self.$vs.loading({type: 'border', text: 'Betöltés'});
      axiosInstance
          .post('admin/optionsController.php', {
            id: self.info.Id,
            val: self.info.OptionValue
          }, {withCredentials: true})
          .then((resp) => {
            self.$vs.notify({
              title: 'Rendszerüzenet',
              position: 'top-right',
              text: resp.data.status === 'OK' ? 'Sikeres mentés.' : 'Sikertelen mentés. ' + resp.data.message,
              color: resp.data.status === 'OK' ? 'success' : 'danger',
              icon: resp.data.status === 'OK' ? 'check_box' : 'error'
            });
            self.editMode = false;
            self.getInformation();
            self.$vs.loading.close();
          })
          .catch((err) => {
            self.$vs.loading.close();
            if (err.response.status === 401)
              self.$root.exterminatus();
            else {
              self.$vs.notify({
                title: 'Rendszerüzenet',
                position: 'top-right',
                text: err.response.data.message,
                color: 'danger',
                icon: 'error'
              });
            }
          });
    },
    editInfo() {
      this.editMode = true;
    },
    cancel() {
      this.getInformation();
      this.editMode = false;
    }
  },
  created() {
    this.getInformation();
  }
}
</script>

<style scoped>
.head {
  margin-bottom: 15px;
}
button {
  margin-left: 3px;
}

</style>